import { KULLANICI_EKLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const KullaniciEkle = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: KULLANICI_EKLE, data });
}

export default KullaniciEkle;